var _rect, _circle, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPastorPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    role: "img",
    "aria-label": "\\uC0AC\\uC9C4 \\uC900\\uBE44\\uC911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "#E8EEEA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 245,
    r: 88,
    fill: "#C5D4CB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270 520c18-108 86-168 180-168s162 60 180 168",
    fill: "#C5D4CB"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 555,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 22,
    fill: "#6B7A70"
  }, "\uC0AC\uC9C4 \uC900\uBE44\uC911")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastorPlaceholder);
export default __webpack_public_path__ + "static/media/pastor_placeholder.4de2bae3ed45d7eedd5082647055373e.svg";
export { ForwardRef as ReactComponent };